export default __webpack_public_path__ + "static/media/Mark of Lightning.811dc37e.jpg";